import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_ERROR_MESSAGE = 'There was an issue. Please review and try again';

const getErrorMessage = () => {
  const { t } = useTranslation();

  return useCallback(
    (err) => err?.response?.body?.message ?? t(DEFAULT_ERROR_MESSAGE),
    [t],
  );
};

export default getErrorMessage;
